import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import csc from 'country-state-city';
import {
  customSelectStyles,
} from '../../../utils';

export default function Country(props) {
  const {
    onChange, value, disabled = false, isMulti,
  } = props;
  const countryOptions = csc.getAllCountries();
  const updateCountryOptions = countryOptions.map((country) => ({
    label: country.name,
    value: country.id,
  }));
  return (
    <Select
      placeholder="Select country"
      className="reactSelect"
      styles={customSelectStyles}
      name="country"
      isDisabled={disabled}
      onChange={onChange}
      options={updateCountryOptions}
      value={value}
      isMulti={isMulti}
    />
  );
}

Country.propTypes = {
  value: PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
};
Country.defaultProps = {
  disabled: false,
  isMulti: false,
  value: null,
};
